import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  competencyProfileId: number;
  onUnpinned: () => Promise<void>;
  userId: number;
}

const ProfileCompetencyProfilePinRemove = ({
  competencyProfileId,
  onUnpinned,
  userId
}: Props) => {
  const { messages } = useReduxState();

  const handleConfirm = async () => {
    await api.delete(
      `/admin/competency-profiles/${competencyProfileId}/pinned-users?userIds=${userId}`
    );
    await onUnpinned();

    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.competencyProfilePinnedUsersUnpin}
      buttonIcon="trash-alt"
      buttonText={messages.competencyProfilePinnedUsersUnpin}
      category="danger"
      confirmText={messages.competencyProfilePinnedUsersUnpinText}
      confirmTitle={messages.competencyProfilePinnedUsersUnpin}
      onConfirm={handleConfirm}
      successMessage={messages.competencyProfilePinnedUsersUnpinSuccess}
    />
  );
};

export default ProfileCompetencyProfilePinRemove;
